import CascadeManager from '../cascade/manager';
import DeferLoadManager from '../deferload/manager';
import DataApi from '../data-view/index';
import pubsubUtils from '../utils/pubsub-utils';
import { removeFormFieldsFromMap } from '../utils/form-handler';
import MessagingServiceManager from '../messagingservice/manager';
import RefreshManager from '../refresh/refresh-manager';
import ContextTreeManager from '../contextree/treemanager';

/**
 * @description
 * Takes care of clearing caches as and when needed
 */
class GarbageCollector {
  /**
   * This function clears various caches related to data context when the context is getting removed
   * @private
   * @param context name of the data context
   */
  static cleanCaches(context: string) {
    // clear cascade manager entries
    CascadeManager.purgeCascadeFields(context);

    // clear deferload manager entries
    DeferLoadManager.removeContext(context);

    // clear DataApi caches
    DataApi.clearContextedCache(context);

    // Clear context pub subs
    pubsubUtils.cleanContextSubscribers(context);

    // Clear form fields cache
    removeFormFieldsFromMap(context);

    ContextTreeManager.removeContextTreeNode(context);

    // Clear messaging service subscriptions
    MessagingServiceManager.clearContext(context);

    // Clear explicit refresh cacheLifeSpan
    RefreshManager.deRegisterForRefresh(context);
  }
}
export default GarbageCollector;
